<div class="w-full">
  <header *ngIf="showSidebar">
    <!-- FULL SIDEBAR -->
    <large-sidebar
      *ngIf="sidebarStatus === 'large'"
      [sidebarStatus]="sidebarStatus"
      (sidebarStatusChange)="toggleSidebarStatus($event)"
    ></large-sidebar>

    <!-- SMALL SIDEBAR -->
    <small-sidebar
      *ngIf="sidebarStatus === 'small'"
      [sidebarStatus]="sidebarStatus"
      (sidebarStatusChange)="toggleSidebarStatus($event)"
    ></small-sidebar>
  </header>

  <div
    [ngClass]="{'ml-[342px] duration-150': sidebarStatus === 'large', 'ml-[66px] duration-300': sidebarStatus === 'small'}"
  >
    <router-outlet />
  </div>
</div>

